export default __webpack_public_path__ + "static/media/persons.473d05fe.png";